import { AudienceId, parseEntityIdSafe } from "@sp-crm/core";
import { Mailchimp } from "components/mailchimp";
import { AudienceShow } from "components/mailchimp/audience-show";
import React from "react";
import { Redirect, Route, Switch } from "react-router";
import { ManageIntegrationAccounts } from "./manage-integration-accounts";
import { ManageIntegrationsNav } from "./manage-integrations-nav";
import { ManageIntegrationsQuickBooks } from "./manage-integrations-quick-books";

export const ManageIntegrations: React.FC<unknown> = () => {
    return (
        <div className="lg:grid lg:grid-cols-12 lg:gap-x-5">
            <div className="lg:col-span-3">
                <ManageIntegrationsNav />
            </div>
            <div className="lg:col-span-9 pb-4">
                <Switch>
                    <Route
                        path="/settings/integrations/accounts"
                        component={ManageIntegrationAccounts}
                    />
                    <Route
                        path="/settings/integrations/quickbooks"
                        component={ManageIntegrationsQuickBooks}
                    />
                    <Route
                        path="/settings/integrations/mailchimp/audiences/:audienceId/:subtab?"
                        render={props => {
                            const audienceIdParam = props.match.params.audienceId;
                            const subtab = props.match.params.subtab || "recipients";
                            const audienceId =
                                parseEntityIdSafe<AudienceId>(audienceIdParam).getOrElse(
                                    null,
                                );

                            if (!audienceId) {
                                return <Redirect to="/settings/integrations/mailchimp" />;
                            }

                            return (
                                <AudienceShow audienceId={audienceId} subtab={subtab} />
                            );
                        }}
                    />
                    <Route
                        path="/settings/integrations/mailchimp"
                        render={props => (
                            <Mailchimp
                                match={{
                                    path: props.match.path,
                                    params: {
                                        subtab: "audiences",
                                    },
                                }}
                            />
                        )}
                    />
                    <Route
                        path="/settings/integrations"
                        render={() => <Redirect to="/settings/integrations/accounts" />}
                    />
                </Switch>
            </div>
        </div>
    );
};
